import { z } from 'zod'

export enum AnalysisStatus {
  Ready = 'ready',
  Pending = 'pending',
  Running = 'running',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

const AnalysisItemsSchema = z.array(
  z.object({
    id: z.string(),
    row_id: z.string(),
    document_id: z.string().nullable(),
    document_name: z.string().nullable().optional(),
    status: z.nativeEnum(AnalysisStatus),
    error: z.string().nullable(),
  })
)

export const AnalysisRunSchema = z.object({
  id: z.string(),
  table_id: z.string(),

  sources: AnalysisItemsSchema,
  cost_limit_reached: z.boolean().optional(),
  next_action: z.enum(['run', 'continue', 'retry']).nullable(),

  counts: z.object({
    ready: z.number().int().nonnegative(),
    pending: z.number().int().nonnegative(),
    running: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    cancelled: z.number().int().nonnegative(),
  }),
})
export type AnalysisRun = z.infer<typeof AnalysisRunSchema>
